export const TYPE_IMAGE = 'picture';
export const TYPE_VIDEO = 'video';
export const TYPE_ARCHIVE = 'archive';
export const TYPE_DOCUMENT = 'document';
//# sourceMappingURL=media-types.js.map